import React, { useEffect, useRef, useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AddIcon from "../../assets/icons/addicon.svg";
import DownArrow from "../../assets/icons/arrowdown.svg";
import search from "../../assets/icons/search.svg";
import "../../assets/styles/local/MemberList.css";
import "../../assets/styles/local/header.css";
import Loader from "../../components/Dailogs/Loader";
import {
  FetchRoleModuleAccess,
  FetchUsersByCompany,
  SendEmailforRegistering,
} from "../../redux/actions/action";
import { Menu, Dropdown, Tooltip } from "antd";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import userAdd from "..//..//assets/icons/userAdd.svg";
import { formattedCurrency } from "..//..//utils/helpers/calculateTime";
import smaliIcon from "..//../assets/icons/meh.svg";
import Header from "..//../layouts/Header";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import filtersIcon from "../../assets/icons/filtersIcon.svg";
import { Close } from "@mui/icons-material";
import Filters from "../../utils/addMember/Filters";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { SEND_EMAIL_REGISTRATION } from "../../redux/constants/type";

const TeamMember = () => {
  const [query, setQuery] = useState("");
  const roleAccess = window.localStorage.getItem("roleid");

  const history = useHistory();
  const [showLoader, setShowLoader] = useState(true);
  const [memberListData, setMemberListData] = useState();
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [showSeethedetails, setShowSeethedetails] = useState(false);
  const [showMemberItem, setShowMemberItem] = useState(false);
  const dispatch = useDispatch();
  const languages = window.localStorage.getItem("language");
  const roleid = window.localStorage.getItem("roleid");
  const companyid = window.localStorage.getItem("companyid");
  const packageId = window.localStorage.getItem("packageId");
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [showWieverUser, setShowWieverUser] = useState(false);
  const [showAddUserButton, setShowAddUserButton] = useState(false);
  const [timeOffEntries, setTimeOffEntries] = useState([]);
  const [allFunctions, setAllFunctions] = useState([]);
  const [allTypeOfEmployees, setAllTypeOfEmployees] = useState([]);
  const [allStatus, setAllStatus] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const FetchUsersByCompanyData = useSelector(
    (state) => state.user.FetchUsersByCompany,
  );
  const [fetchTransCoWorkersList, setFetchTransCoWorkersList] = useState({});
  const t = (key) => fetchTransCoWorkersList?.[key] || "";
  const roleModuleData = useSelector(
    (state) => state?.user?.FetchRoleModuleAccess,
  );
  const emailRes = useSelector((state) => state?.user?.emailRes);

  useEffect(() => {
    fetchMemberList();
  }, [query]);

  useEffect(() => {
    fetchScreenTranslations("Co-Workers-List").then((res) => {
      setFetchTransCoWorkersList(res);
    });
    dispatch(FetchRoleModuleAccess(roleid));
  }, []);

  const fetchMemberList = () => {
    if (query) {
      dispatch(FetchUsersByCompany(companyid, 0, 0));
    } else {
      dispatch(FetchUsersByCompany(companyid, 0, 0));
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const fetchListData = () => {
    if (FetchUsersByCompanyData != null) {
      if (FetchUsersByCompanyData?.data?.status === true) {
        preparePagination(FetchUsersByCompanyData?.data.totalCount);
        if (query) {
          let tempMembers = [...FetchUsersByCompanyData?.data?.data];
          tempMembers = tempMembers?.filter((list) => {
            const activeMember =
              list?.substatus && list?.substatus !== ""
                ? list?.substatus
                : list?.userdetails[0]?.isactive === 1
                  ? t("Active") // for Active.
                  : list?.userdetails[0]?.isactive === 0
                    ? t("Non Active") // for Non Active.
                    : list?.userdetails[0]?.isactive === 2
                      ? t("Pending") // for Pending.
                      : "";

            const fullName = `${list?.userdetails[0]?.firstname} ${
              list?.userdetails[0]?.lastname
                ? list?.userdetails[0]?.lastname
                : ""
            }`;

            return (
              fullName?.toLowerCase().includes(query.toLowerCase()) ||
              activeMember?.toLowerCase().includes(query.toLowerCase()) ||
              list?.userdetails[0]?.firstname
                .toLowerCase()
                .includes(query.toLowerCase()) ||
              list?.userdetails[0]?.jobid[0]?.jobtypename
                ?.toLowerCase()
                .includes(query?.toLowerCase()) ||
              list?.userdetails[0]?.type
                ?.toLowerCase()
                .includes(query?.toLowerCase()) ||
              list.userdetails[0]?.phonenumber?.toLowerCase().includes(query) ||
              list?.userdetails[0]?.contracttype
                ?.toLowerCase()
                .includes(query?.toLowerCase()) ||
              list?.userdetails[0]?.jobpost
                ?.toLowerCase()
                .includes(query?.toLowerCase()) ||
              list?.userdetails[0]?.billrate
                ?.toLocaleString("de-DE", {
                  style: "currency",
                  currency: "EUR",
                })
                ?.toLowerCase()
                ?.includes(query?.toLowerCase()) ||
              list?.userdetails[0]?.wagerate
                ?.toLocaleString("de-DE", {
                  style: "currency",
                  currency: "EUR",
                })
                ?.toLowerCase()
                ?.includes(query?.toLowerCase()) ||
              list?.userdetails[0]?.type
                ?.toLowerCase()
                .includes(query?.toLowerCase())
            );
          });

          setMemberListData(tempMembers);
          setFilteredList(tempMembers);
        } else {
          setMemberListData(FetchUsersByCompanyData?.data?.data);
          setFilteredList(FetchUsersByCompanyData?.data?.data);
        }

        setTimeout(() => {
          setShowLoader(false);
        }, 1000);
      } else {
      }
    }
  };

  useEffect(() => {
    fetchListData();
  }, [FetchUsersByCompanyData]);

  const preparePagination = (totalRecords) => {
    const totalPages = Math.ceil(totalRecords / perPage);
    setTotalPages(totalPages);
  };

  const PaginationChange = (event) => {
    setCurrentPage(event.selected);
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [perPage]);

  useEffect(() => {
    if (filteredList && filteredList.length >= 0)
      preparePagination(filteredList?.length);
  }, [filteredList, perPage]);

  const refPaymentTypeDropDownContainer = useRef();

  const handleMouseDowPaymentDD = (event) => {
    if (
      refPaymentTypeDropDownContainer.current &&
      !refPaymentTypeDropDownContainer.current.contains(event.target)
    ) {
      setShowMemberItem(false);
    }
  };

  useEffect(() => {
    if (showMemberItem) {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowPaymentDD);
    };
  }, [showMemberItem]);

  React.useEffect(() => {
    if (roleModuleData?.status === 200) {
      for (let i = 0; i < roleModuleData?.data?.data?.length; i++) {
        if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df311" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60035"
        ) {
          setShowSeethedetails(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df311" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60057"
        ) {
          setShowWieverUser(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976024" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df311" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60058"
        ) {
          setShowAddUserButton(true);
        } else if (
          roleModuleData?.data[i]?.moduleid ==
            "08da4e8a-6050-40db-8d54-5751dc976017" &&
          (roleModuleData?.data[i]?.accesslevelsid ==
            "08da33e9-5a64-4f8c-8d88-49e4982df320" ||
            roleModuleData?.data[i]?.accesslevelsid ==
              "08da33e9-5a64-4f8c-8d88-49e4982df321")
        ) {
          // setShowSetting(true);
        }
      }
    } else {
    }
  }, [roleModuleData]);

  const items = [
    {
      key: "0",
      label: (
        <div onClick={() => history.push("/Teams")}>
          {/* Teams */}
          {t("Teams")}
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={() => history.push("/Schedule")}>
          {/* Schedule */}
          {t("Schedule")}
        </div>
      ),
    },
    {
      key: "2",
      // label: "Vacation Reports",
      label: t("Vacation Reports"),
    },
  ];

  const showTooltipComp = (item) => {
    return (
      <div
        className="spireText5 d-flex gap-3 py-1 px-3 pointer"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            SendEmailforRegistering(companyid, item?.userdetails[0]?.email),
          );
        }}
      >
        Resend invite
      </div>
    );
  };

  useEffect(() => {
    if (emailRes?.status === true) {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: `Invite sent successfully`,
      });

      dispatch({
        type: SEND_EMAIL_REGISTRATION,
        data: {},
      });
    }
  }, [emailRes]);

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            className="flex-wrap gap-5 d-flex align-items-baseline"
            style={{ display: "flex", gap: "10%" }}
          >
            <div
              className="fw-bold "
              style={{
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Co-Worker */}
              {t("Co-Workers")}
            </div>
            <Dropdown
              trigger={["click"]}
              menu={{ items }}
              open={dropDownOpen}
              onOpenChange={(e) => setDropDownOpen(e)}
            >
              <div
                className="fw-bold dropdown col-3 HideForTablet"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "0.5px solid #e0dada",
                  borderRadius: "8px",
                }}
              >
                <span
                  className="fw-bold "
                  onClick={() => {
                    history.push("/member-list");
                  }}
                >
                  {/* Employees */}
                  {t("Employees")}
                </span>
                {dropDownOpen ? <UpOutlined /> : <DownOutlined />}
              </div>
            </Dropdown>
          </div>
        }
      />

      {showLoader === true ? (
        <div
          className="text-center "
          style={{
            color: "#003766",
            fontSize: "14px",
            fontWeight: "700",
          }}
        >
          <Loader />
        </div>
      ) : (
        <div className="parent">
          <searchSection>
            {" "}
            {/* search for mobile view */}
            <div className="member_searchShow" style={{ position: "relative" }}>
              <input
                className="member_search_input_input"
                type="text"
                placeholder=""
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
              <img className="member_search_input_icon" src={search} alt="" />
            </div>
          </searchSection>
          <div className="outer">
            <Row>
              <Col xs={6} xl={9} className="p-0">
                <p
                  className="fw-bold ps-4 mt-2 d-none ascCoworkerTXTShowHide"
                  style={{
                    fontSize: "clamp(20px, 1.354vw, 1.354vw)",
                    color: "#333333",
                  }}
                >
                  {t("Co-Workers")}
                </p>
                <Filters
                  alwaysVisible={true}
                  onSubmit={(values) => {
                    if (values === "all") setFilteredList(memberListData);
                    else if (values && values.length > 0) {
                      const object = values[0];
                      let type = "";

                      if (object.hasOwnProperty("jobtypename"))
                        type = "jobtypename";
                      else if (object.hasOwnProperty("employeeTypeName"))
                        type = "employeeTypeName";
                      else if (object.hasOwnProperty("statusLabel"))
                        type = "statusLabel";

                      if (type === "jobtypename") {
                        let arr = [];
                        for (let key of values) {
                          let list = [...memberListData];
                          list = list.filter(
                            (row) =>
                              key.jobtypename ===
                              row?.userdetails[0]?.jobid[0]?.function,
                          );
                          arr = [...arr, ...list];
                        }
                        setFilteredList(arr);
                        //  list?.userdetails[0]?.jobid[0]?.function;
                        //  list?.userdetails[0]?.contracttype;
                      } else if (type === "employeeTypeName") {
                        let arr = [];
                        for (let key of values) {
                          let list = [...memberListData];
                          list = list.filter(
                            (row) =>
                              key.employeeTypeName ===
                              row?.userdetails[0]?.contracttype,
                          );
                          arr = [...arr, ...list];
                        }
                        setFilteredList(arr);
                      } else if (type === "statusLabel") {
                        let arr = [];
                        for (let key of values) {
                          let list = [...memberListData];
                          list = list.filter((row) => {
                            const activeMember =
                              row?.substatus && row?.substatus !== ""
                                ? row?.substatus
                                : row?.userdetails[0]?.isactive === 1
                                  ? "Active"
                                  : row?.userdetails[0]?.isactive === 0
                                    ? "Non Active"
                                    : row?.userdetails[0]?.isactive === 2
                                      ? "Pending"
                                      : "";
                            return activeMember === key.statusLabel;
                          });
                          arr = [...arr, ...list];
                        }
                        setFilteredList(arr);
                      }
                    } else setFilteredList(memberListData);
                  }}
                />
              </Col>
              <Col xs={6} xl={3} className="add-col-item pe-0">
                <div
                  onClick={() => {
                    history.push("/add-member");
                  }}
                  // className="d-flex add-member-btn"
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : roleAccess === process.env.REACT_APP_IS_USER
                        ? "d-none"
                        : "d-flex add-member-list-btn addMemberBtnsHide"
                  }
                >
                  <Image
                    height={17}
                    width={17}
                    src={AddIcon}
                    className="addicon"
                  />
                  <Image
                    height={17}
                    width={16}
                    src={userAdd}
                    className="useradd"
                  />
                  {/* <div className="member-add-image" /> */}
                  <p className="add-member-text ms-3 mb-0">
                    {t("Add Co-worker")}
                  </p>
                </div>
              </Col>
            </Row>

            <div
              className="row table-responsive mt-2 member-list-dive table-container-member-list"
              style={
                {
                  // opacity: 1,
                  // height: "72.6vh",
                }
              }
            >
              {filteredList?.length ? (
                <table class="table addmember-list-tbody add-member-table">
                  <thead>
                    <tr className="member-list-effect">
                      <th className="pb-1 forTableViewMemberWidth">
                        <p
                          className=" table-item-member mt-2 mb-0 "
                          style={{
                            marginLeft: "19px",
                          }}
                        >
                          {t("Co-Worker")}
                          {/* Co-Worker */}
                        </p>
                      </th>
                      <th className="pb-1 ps-2 ascHideForMobile HideForTablet">
                        <p
                          className="table-item-member mt-2  mb-0 "
                          style={{
                            marginLeft: "2px",
                          }}
                        >
                          {t("Function")}
                          {/* Function */}
                        </p>
                      </th>
                      {packageId === process.env.REACT_APP_IS_PREMIUM && (
                        <th className="pb-1 ps-2 ascHideForMobile HideForTablet">
                          <p
                            className="table-item-member mt-2 mb-0 ps-0"
                            style={{
                              marginLeft: "35px",
                            }}
                          >
                            {/* Team */}
                            {t("Teams")}
                          </p>
                        </th>
                      )}
                      <th className="pb-1 ps-2 ascHideForMobile">
                        <p
                          className="table-item-member mt-2 mb-0 ps-0"
                          style={{
                            marginLeft: "20px",
                          }}
                        >
                          {t("Contact")}
                        </p>
                      </th>
                      {!showWieverUser && (
                        <th className="pb-1 ps-2 ascHideForMobile HideForTablet">
                          <p
                            className="table-item-member mt-2 mb-0 ps-0"
                            style={{
                              marginLeft: "2px",
                            }}
                          >
                            {t("Payment")}
                          </p>
                        </th>
                      )}
                      {!showWieverUser && (
                        <th className="pb-1 ps-2 ascHideForMobile HideForTablet">
                          <p
                            className="table-item-member mt-2 mb-0 ps-0"
                            style={{
                              marginLeft: "2px",
                            }}
                          >
                            {t("Types of Employee")}
                            {/* Type of employee */}
                          </p>
                        </th>
                      )}
                      {!showWieverUser && (
                        <th className="ps-0">
                          <p
                            className="table-item-member mt-2 mb-0 ps-2"
                            style={{}}
                          >
                            {t("Status")}
                          </p>
                        </th>
                      )}
                      {showWieverUser && (
                        <th className="pb-1 ps-2">
                          <p
                            className="table-item-member mt-2 mb-0 ps-0"
                            style={{
                              marginLeft: "32px",
                            }}
                          >
                            {/* Email */}
                            {t("Email")}
                          </p>
                        </th>
                      )}
                      {showWieverUser && (
                        <th className="ps-0">
                          <p
                            className="table-item-member mt-2 mb-0 ps-2"
                            style={{}}
                          >
                            {/* Birthday */}
                            {t("Birthday")}
                          </p>
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody
                  //   style={{
                  //     display: "block",
                  //     maxHeight: "57.6852vh",
                  //     overflowY: "scroll",
                  //   }}
                  >
                    {filteredList
                      ?.slice(
                        currentPage * perPage,
                        currentPage * perPage + perPage,
                      )
                      ?.map((list, i) => {
                        let abbrevation = "";
                        if (list?.userdetails[0]?.initials)
                          abbrevation =
                            list?.userdetails[0]?.initials?.toUpperCase();
                        else if (list?.userdetails[0]?.firstname) {
                          const array =
                            list?.userdetails[0]?.firstname.split(" ");
                          for (let i = 0; i < array.length; i++) {
                            abbrevation += array[i][0]?.toUpperCase();
                          }
                        }
                        return (
                          <>
                            <tr
                              key={list?.userid}
                              onClick={() => {
                                if (showSeethedetails) {
                                  if (
                                    list?.substatus &&
                                    list?.substatus !== "" &&
                                    list?.substatus === "Requested"
                                  ) {
                                    history.push(
                                      `/updat-member/${list?.userid}/${list?.projectcode}/${list?.projecthiringid}`,
                                    );
                                  } else {
                                    history.push(
                                      `/updat-member/${list?.userid}`,
                                    );
                                  }
                                }
                                // history.push(`/updat-member/${list?.userid}`)
                              }}
                              // className="member-list-effect"
                              className={
                                roleAccess === process.env.REACT_APP_IS_VIEWER
                                  ? "align-middle pointerEvent member-list-effect"
                                  : roleAccess === process.env.REACT_APP_IS_USER
                                    ? "align-middle pointerEvent member-list-effect"
                                    : "align-middle member-list-effect"
                              }
                            >
                              <td
                                style={{
                                  width: "20%",
                                }}
                                className="py-0"
                              >
                                <div className="d-flex ms-4 margen-5 align-items-center">
                                  <div
                                    style={{
                                      borderRadius: "50%",
                                      // width: "2.292vw",
                                      // height: "2.292vw",
                                      marginRight: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      // cursor: "pointer",
                                    }}
                                    className="avtar-icon"
                                  >
                                    {list?.userdetails[0]?.imageurl ? (
                                      <Image
                                        // className="mt-3"
                                        alt="userImg"
                                        src={list?.userdetails[0]?.imageurl}
                                        style={{
                                          borderRadius: "50%",
                                          // cursor: "pointer",
                                          width: "35px",
                                          height: "35px",
                                          objectFit: "cover",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          display: "flex",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          borderRadius: "50%",
                                          width: "35px",
                                          height: "35px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          // cursor: "pointer",
                                          color: "#FFFFFF",
                                          fontSize:
                                            "clamp(14px, 0.729vw, 0.729vw)",
                                          fontWeight: 500,
                                          background:
                                            "#95A7C6 0% 0% no-repeat padding-box",
                                        }}
                                        className="avtar-icon"
                                      >
                                        {abbrevation}
                                        {/* {list?.userdetails[0]?.firstname.charAt(0).toUpperCase()}
                                                            {list?.userdetails[0]?.lastname.charAt(0).toUpperCase()} */}
                                      </div>
                                    )}
                                  </div>
                                  <p
                                    className="ms-2 table-item  mb-0 pl-5 ml-5"
                                    style={{
                                      fontWeight: "bold",
                                      // cursor: "pointer",
                                      fontSize: "clamp(14px, 0.729vw, 0.729vw)",
                                      // marginTop: "10px",
                                      color: `${
                                        list?.userdetails[0]?.isactive === 0
                                          ? "#a5a5a580"
                                          : "#333333"
                                      }`,
                                    }}
                                  >
                                    {`${
                                      list?.userdetails[0]?.firstname
                                        ? list?.userdetails[0]?.firstname
                                        : "" +
                                            " " +
                                            list?.userdetails[0]?.lastname
                                          ? list?.userdetails[0]?.lastname
                                          : ""
                                    }`}
                                  </p>
                                </div>
                              </td>
                              <td className="py-0 ascHideForMobile HideForTablet">
                                <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center">
                                  <p
                                    className="table-item  mb-0"
                                    style={{
                                      fontWeight: 400,
                                      marginLeft: "10px",
                                      fontSize: "clamp(14px, 0.729vw, 0.729vw)",
                                      color: `${
                                        list?.userdetails[0]?.isactive === 0
                                          ? "#a5a5a580"
                                          : "#333333"
                                      }`,
                                    }}
                                  >
                                    {list?.userdetails[0]?.jobid[0]?.function
                                      ? list?.userdetails[0]?.jobid[0]?.function
                                      : "--"}
                                  </p>
                                </div>
                              </td>
                              {packageId ===
                                process.env.REACT_APP_IS_PREMIUM && (
                                <td className="py-0 ascHideForMobile HideForTablet">
                                  <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center">
                                    <p
                                      className="table-item  mb-0"
                                      style={{
                                        fontWeight: 400,
                                        fontSize:
                                          "clamp(14px, 0.729vw, 0.729vw)",
                                        marginLeft: "35px",
                                        marginRight: "25px",
                                        color: `${
                                          list?.userdetails[0]?.isactive === 0
                                            ? "#a5a5a580"
                                            : "#333333"
                                        }`,
                                      }}
                                    >
                                      {list?.teamcount === 0
                                        ? "--"
                                        : list?.teamcount === 1
                                          ? "1 Team"
                                          : `${list?.teamcount} Teams`}
                                    </p>
                                  </div>
                                </td>
                              )}
                              <td className="py-0 ascHideForMobile">
                                <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center">
                                  <p
                                    className="table-item  mb-0"
                                    // className="mb-0 margen-active-7"
                                    style={{
                                      fontWeight: 400,
                                      marginLeft: "25px",
                                      fontSize: "clamp(14px, 0.729vw, 0.729vw)",
                                      color: `${
                                        list?.userdetails[0]?.isactive === 0
                                          ? "#a5a5a580"
                                          : "#333333"
                                      }`,
                                    }}
                                  >
                                    {list?.userdetails[0]?.phonenumber !==
                                    "" ? (
                                      <PhoneInput
                                        containerClass={
                                          "member-list-phone-number"
                                        }
                                        country={"nl"}
                                        enableSearch={true}
                                        value={
                                          list?.userdetails[0]?.phonenumber
                                        }
                                        inputStyle={{
                                          fontSize:
                                            "clamp(14px, 0.729vw, 0.729vw)",
                                          fontWeight: 400,
                                        }}
                                      />
                                    ) : (
                                      "--"
                                    )}
                                  </p>
                                </div>
                              </td>
                              {!showWieverUser && (
                                <td className="py-0 ascHideForMobile HideForTablet">
                                  <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center">
                                    <p
                                      className="table-item  mb-0"
                                      style={{
                                        fontWeight: 400,
                                        fontSize:
                                          "clamp(14px, 0.729vw, 0.729vw)",
                                        // width: "49px",
                                        color: `${
                                          list?.userdetails[0]?.isactive === 0
                                            ? "#a5a5a580"
                                            : "#333333"
                                        }`,
                                      }}
                                    >
                                      {list?.userdetails[0]?.type
                                        ? list?.userdetails[0]?.type + ":"
                                        : ""}
                                    </p>
                                    <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center">
                                      {
                                        // <input
                                        //   className="add-member-input add-member-no-border"
                                        //   value={formattedCurrency(
                                        //     list?.userdetails[ 0 ]?.wagerate
                                        //   )}
                                        //   type="text"
                                        //   disabled
                                        //   onChange={(e, value) => { }}
                                        //   style={{
                                        //     fontWeight: "bold",
                                        //     fontSize: "clamp(14px, 0.729vw, 0.729vw)",
                                        //     width: "58px",
                                        //     height: "30px",
                                        //     marginTop: "5px",
                                        //     color: `${list?.userdetails[ 0 ]?.isactive === 0
                                        //       ? "#a5a5a580" : "#333333"
                                        //       }`
                                        //   }}
                                        // />
                                        <p
                                          className="table-item  mb-0 noborder-member-list"
                                          style={{
                                            // fontWeight: "bold",
                                            // height: "30px",
                                            // marginTop: "10px",
                                            color: `${
                                              list?.userdetails[0]?.isactive ===
                                              0
                                                ? "#a5a5a580"
                                                : "#333333"
                                            }`,
                                          }}
                                        >
                                          {formattedCurrency(
                                            list?.userdetails[0]?.wagerate,
                                          )}
                                        </p>
                                      }
                                      {list?.userdetails[0]?.wagerate && (
                                        <p
                                          className="table-item  mb-0 Payment-dived noborder-member-list"
                                          style={{
                                            // marginTop: "10px",
                                            marginLeft: "3px",
                                            marginRight: "3px",
                                            color: `${
                                              list?.userdetails[0]?.isactive ===
                                              0
                                                ? "#a5a5a580"
                                                : "#333333"
                                            }`,
                                          }}
                                        >
                                          |
                                        </p>
                                      )}{" "}
                                      {
                                        // <input
                                        //   className="add-member-input add-member-no-border"
                                        //   value={formattedCurrency(
                                        //     list?.userdetails[ 0 ]?.billrate
                                        //   )}
                                        //   type="text"
                                        //   disabled
                                        //   onChange={(e, value) => { }}
                                        //   style={{
                                        //     fontSize: "clamp(14px, 0.729vw, 0.729vw)",
                                        //     width: "58px",
                                        //     height: "30px",
                                        //     marginTop: "5px",
                                        //     color: `${list?.userdetails[ 0 ]?.isactive === 0
                                        //       ? "#a5a5a580" : "#333333"
                                        //       }`
                                        //   }}
                                        // />
                                        <p
                                          className="table-item  mb-0 noborder-member-list"
                                          style={{
                                            // fontWeight: "bold",
                                            // height: "30px",
                                            // marginTop: "10px",
                                            color: `${
                                              list?.userdetails[0]?.isactive ===
                                              0
                                                ? "#a5a5a580"
                                                : "#333333"
                                            }`,
                                          }}
                                        >
                                          {formattedCurrency(
                                            list?.userdetails[0]?.billrate,
                                          )}
                                        </p>
                                      }
                                    </div>
                                  </div>
                                </td>
                              )}
                              {!showWieverUser && (
                                <td className="py-0 ascHideForMobile HideForTablet">
                                  <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center">
                                    <p
                                      className="table-item  mb-0"
                                      style={{
                                        fontWeight: 400,
                                        fontSize:
                                          "clamp(14px, 0.729vw, 0.729vw)",
                                        marginLeft: "2px",
                                        color: `${
                                          list?.userdetails[0]?.isactive === 0
                                            ? "#a5a5a580"
                                            : "#333333"
                                        }`,
                                      }}
                                    >
                                      {list?.userdetails[0]?.contracttype}
                                    </p>
                                  </div>
                                </td>
                              )}
                              {!showWieverUser && (
                                <td className="py-0">
                                  <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center row-gap-co-worker">
                                    <Tooltip
                                      // title={showTooltipComp(list)}
                                      title={
                                        list?.userdetails[0]?.isactive === 2
                                          ? showTooltipComp(list)
                                          : null
                                      }
                                      color={"white"}
                                      overlayInnerStyle={{
                                        color: "black",
                                        fontWeight: "500",
                                      }}
                                    >
                                      <p
                                        className="table-item  mb-0"
                                        // className="mb-0 margen-active-7"
                                        style={{
                                          // marginTop: "8px",
                                          fontSize:
                                            "clamp(14px, 0.729vw, 0.729vw)",
                                          // marginLeft: "5px",
                                          // : 400,
                                          fontWeight: `${
                                            list?.userdetails[0]?.isactive === 1
                                              ? 400
                                              : list?.userdetails[0]
                                                    ?.isactive === 0
                                                ? 400
                                                : list?.userdetails[0]
                                                      ?.isactive === 2
                                                  ? 900
                                                  : ""
                                          }`,
                                          color: `${
                                            list?.userdetails[0]?.isactive === 1
                                              ? "#333333"
                                              : list?.userdetails[0]
                                                    ?.isactive === 0
                                                ? "#a5a5a580"
                                                : list?.userdetails[0]
                                                      ?.isactive === 2
                                                  ? "#00246A"
                                                  : ""
                                          }`,
                                        }}
                                      >
                                        {list?.substatus &&
                                        list?.substatus !== ""
                                          ? list?.substatus
                                          : list?.userdetails[0]?.isactive === 1
                                            ? t("Active")
                                            : list?.userdetails[0]?.isactive ===
                                                0
                                              ? t("Non Active")
                                              : list?.userdetails[0]
                                                    ?.isactive === 2
                                                ? t("Pending")
                                                : ""}
                                      </p>
                                    </Tooltip>
                                  </div>
                                </td>
                              )}
                              {showWieverUser && (
                                <td className="py-0">
                                  <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center row-gap-co-worker">
                                    <p
                                      className="table-item  mb-0"
                                      // className="mb-0 margen-active-7 "
                                      style={{
                                        fontWeight: 400,
                                        fontSize:
                                          "clamp(14px, 0.729vw, 0.729vw)",
                                        marginLeft: "32px",
                                        color: `${
                                          list?.userdetails[0]?.isactive === 0
                                            ? "#a5a5a580"
                                            : "#333333"
                                        }`,
                                      }}
                                    >
                                      {list?.userdetails[0]?.email}
                                    </p>
                                  </div>
                                </td>
                              )}
                              {showWieverUser && (
                                <td className="py-0">
                                  <div className="h-100 d-flex align-items-end mb-0 p-0 m-d-flex align-items-center row-gap-co-worker">
                                    <p
                                      className="table-item  mb-0"
                                      // className="mb-0 margen-active-7 "
                                      style={{
                                        fontWeight: 400,
                                        fontSize:
                                          "clamp(14px, 0.729vw, 0.729vw)",
                                        // marginLeft: "32px",
                                        color: `${
                                          list?.userdetails[0]?.isactive === 0
                                            ? "#a5a5a580"
                                            : "#333333"
                                        }`,
                                      }}
                                    >
                                      {list?.userdetails[0]?.dateofbirth}
                                    </p>
                                  </div>
                                </td>
                              )}
                            </tr>
                          </>
                        );
                      })}
                  </tbody>
                </table>
              ) : (
                <div style={{ height: "569px" }}>
                  <table class="table ">
                    <thead>
                      <tr className="">
                        <th className="pb-1">
                          <p
                            className="ms-4 table-item mt-2"
                            style={{
                              fontWeight: "bold",
                              fontSize: "clamp(12px, 0.938vw, 0.938vw)",
                              color: "#333333",
                            }}
                          >
                            {t("Members")}
                          </p>
                        </th>
                        <th className="pb-1">
                          <p
                            className="table-item mt-2"
                            style={{
                              fontWeight: "bold",
                              fontSize: "clamp(12px, 0.938vw, 0.938vw)",
                              color: "#333333",
                            }}
                          >
                            {t("Job title")}
                          </p>
                        </th>
                        <th className="pb-1">
                          <p
                            className="table-item mt-2"
                            style={{
                              fontWeight: "bold",
                              fontSize: "clamp(12px, 0.938vw, 0.938vw)",
                              color: "#333333",
                            }}
                          >
                            {t("Contact")}
                          </p>
                        </th>
                        <th className="pb-1">
                          <p
                            className="table-item mt-2"
                            style={{
                              fontWeight: "bold",
                              fontSize: "clamp(12px, 0.938vw, 0.938vw)",
                              color: "#333333",
                            }}
                          >
                            {t("Payment")}
                          </p>
                        </th>
                        <th className="pb-1">
                          <p
                            className="table-item mt-2"
                            style={{
                              fontWeight: "bold",
                              fontSize: "clamp(12px, 0.938vw, 0.938vw)",
                              color: "#333333",
                            }}
                          >
                            {t("Contract Type")}
                          </p>
                        </th>
                        <th>
                          <p
                            className="table-item mt-2"
                            style={{
                              fontWeight: "bold",
                              fontSize: "clamp(12px, 0.938vw, 0.938vw)",
                              color: "#333333",
                            }}
                          >
                            {t("Status")}
                          </p>
                        </th>
                        {showWieverUser && (
                          <th className="pb-1 ps-2">
                            <p
                              className="table-item-member mt-2 mb-0 ps-0"
                              style={{
                                marginLeft: "32px",
                              }}
                            >
                              {/* Email */}
                              {t("Email")}
                            </p>
                          </th>
                        )}
                        {showWieverUser && (
                          <th className="ps-0">
                            <p
                              className="table-item-member mt-2 mb-0 ps-2"
                              style={{}}
                            >
                              {/* Birthday */}
                              {t("Birthday")}
                            </p>
                          </th>
                        )}
                      </tr>
                    </thead>
                  </table>
                  <div className="row container mt-5 pt-5">
                    <img
                      src={smaliIcon}
                      alt="smali"
                      width={35}
                      height={35}
                      className="mt-5 "
                    />
                    <h6
                      className="mt-1"
                      style={{
                        // color: `${FetchCompanyThemRes[0]?.textcolor
                        //     ? FetchCompanyThemRes[0]?.textcolor
                        //     : "#333333"
                        //     }`,
                        fontSize: "14px",
                        fontWeight: 400,
                        textAlign: "center",
                        color: "#707070",
                      }}
                    >
                      {t("Sorry.")}
                      <br /> {t("No results for your criteria.")}
                      <br />{" "}
                      {t("Try to refine your seardh or enter a new search.")}
                    </h6>
                  </div>
                </div>
              )}
            </div>
            <div className="align-text-bottom pb-5 mb-3">
              <Row>
                <Col xs={6} xl={9}>
                  <p
                    className="fw-bold mt-2 "
                    style={{
                      fontSize: "20px",
                      color: "#333333",
                      display: "flex",
                      alignItems: "baseline",
                    }}
                  >
                    <p
                      className="table-item mb-1"
                      style={{
                        fontWeight: 400,
                        fontSize: "clamp(10px, 0.729vw, 0.729vw)",
                      }}
                    >
                      {t("Items per page")}
                    </p>

                    <div
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "5px",
                        alignItems: "center",
                      }}
                      className="ms-2 "
                    >
                      <p
                        className="margin-0"
                        style={{
                          fontSize: "clamp(10px, 0.729vw, 0.729vw)",
                          fontWeight: "bold",
                          color: "#333333",
                          flexGrow: "1",
                          textTransform: "capitalize",
                        }}
                        onClick={() => setShowMemberItem(!showMemberItem)}
                      >
                        {perPage}
                      </p>
                      <BsChevronDown
                        size={10}
                        style={{
                          flexGlow: "1",
                          color: "#333333",
                        }}
                        onClick={() => setShowMemberItem(!showMemberItem)}
                        className="down-arrow bi-paperclip ms-1"
                      />
                      {showMemberItem && (
                        <div
                          className="drop-down-member-item d-flex align-items-end p-1"
                          id="lang-drop-down"
                          ref={refPaymentTypeDropDownContainer}
                        >
                          <div>
                            {[10, 20, 50]?.map((item, i) => {
                              return (
                                <div>
                                  <p
                                    key={i}
                                    className="margin-0 ms-2 pb-1"
                                    style={{
                                      opacity: 1,
                                      fontSize: "clamp(10px, 0.729vw, 0.729vw)",
                                      fontWeight: `${
                                        item === perPage ? 800 : "bold"
                                      }`,
                                      color: `${
                                        item === perPage ? "#95A7C6" : "#333333"
                                      }`,
                                    }}
                                    onClick={() => {
                                      setPerPage(item);
                                      setShowMemberItem(false);
                                    }}
                                  >
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                          <BsChevronDown
                            size={10}
                            style={{
                              fontWeight: "bold",
                              flexGlow: "1",
                              color: "#333333",
                            }}
                            className="mb-1 ms-1 down-arrow down-arrow-rotate bi-paperclip"
                          />
                        </div>
                      )}
                    </div>
                  </p>
                </Col>
                <Col xs={6} xl={3} className="add-col-item">
                  <div className="table-filter-info-member">
                    <ReactPaginate
                      nextLabel=""
                      forcePage={currentPage}
                      disableInitialCallback={true}
                      onPageChange={PaginationChange}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      pageCount={totalPages}
                      previousLabel=""
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="d-none"
                      nextClassName="d-none"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="app-pagination"
                      activeClassName="active"
                      renderOnZeroPageCount={null}
                    />
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <Col
                onClick={() => {
                  history.push("/add-member");
                }}
                // className="d-flex add-member-btn"
                className={
                  roleAccess === process.env.REACT_APP_IS_VIEWER
                    ? "d-none"
                    : roleAccess === process.env.REACT_APP_IS_USER
                      ? "d-none"
                      : "d-flex add-member-list-btn d-none addButtonMobile ms-4"
                }
                style={{ borderRadius: "8px" }}
              >
                <Image
                  height={17}
                  width={17}
                  src={AddIcon}
                  className="addicon"
                />
                <Image
                  height={17}
                  width={16}
                  src={userAdd}
                  className="useradd"
                />
                {/* <div className="member-add-image" /> */}
                <p className="add-member-text ms-3 mb-0">
                  {t("Add Co-worker")}
                </p>
              </Col>
            </Row>
            {/* add button for mobile view end */}
          </div>
        </div>
      )}
    </>
  );
};

const Pagginesstionitem = ({
  size,
  pageSize,
  pageNumbersMain,
  selectPage,
  page,
}) => {
  return (
    <>
      <Row>
        <Col xl={9}>
          <p
            className="fw-bold mt-2 "
            style={{
              fontSize: "20px",
              color: "#333333",
              display: "flex",
            }}
          >
            <p
              className="table-item mb-1"
              style={{
                fontWeight: 400,
              }}
            >
              {/* {fetchTransCoWorkersList[2]?.translation} */}
            </p>
            <select
              value={pageSize}
              onChange={(e) => {
                size(Number(e.target.value));
              }}
              className="Items-per-page ms-1"
            >
              {[10, 20, 30].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </select>
            {/* Members */}
          </p>
        </Col>
        <Col xl={3} className="add-col-item">
          {pageNumbersMain?.map((pages, index) => {
            return (
              <div
                // className="page-number-style"
                // style={
                //   page === pages
                //     ? { fontWeight: "700" }
                //     : { fontWeight: "400" }
                // }
                className={
                  page === pages
                    ? "select-page-number-style mt-2"
                    : "mt-2 page-number-style"
                }
                onClick={() => selectPage(pages)}
              >
                {pages}
              </div>
            );
          })}
        </Col>
      </Row>
    </>
  );
};

export default TeamMember;
